import { Link, useNavigate } from "react-router-dom";
import { LogOut, LayoutGrid, Plus, ExternalLink, Inbox } from "lucide-react";import { useAuth } from "@/context/AuthContext";
import { useLab } from "@/context/LabContext";

const WEBSITE_URL = "https://www.commongroundinstitute.net";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { reset } = useLab();
  const navigate = useNavigate();

  const startNew = () => {
    reset();
    navigate("/lab");
  };

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-[#FDFBF7]/85 backdrop-blur-md border-b border-[#E8E3D9]">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3" data-testid="navbar-brand">
          <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer" data-testid="navbar-logo-link" aria-label="Common Ground Institute website">
            <img src="/cgi-logo.png" alt="Common Ground Institute" className="h-8 w-auto" />
          </a>
          <span className="hidden sm:block h-6 w-px bg-[#E8E3D9]" />
          <Link to={user ? "/dashboard" : "/"} className="hidden sm:block font-serif text-lg tracking-tight text-[#2D2A26]" data-testid="navbar-home-link">Common Ground Explorer</Link>
        </div>
        {user && (
          <nav className="flex items-center gap-2">
            <a
              href={WEBSITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="navbar-website-link"
              className="hidden md:flex items-center gap-1.5 px-3 py-2 rounded-full text-sm text-[#6E6860] hover:text-[#2D2A26] hover:bg-[#F5F2EA] transition-colors"
            >
              <ExternalLink className="h-4 w-4" strokeWidth={1.5} /> Back to Website
            </a>
            <Link
              to="/dashboard"
              data-testid="navbar-dashboard-link"
              className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-full text-sm text-[#6E6860] hover:text-[#2D2A26] hover:bg-[#F5F2EA] transition-colors"
            >
              <LayoutGrid className="h-4 w-4" strokeWidth={1.5} /> My Maps
            </Link>
            {user.role === "admin" && (
              <Link
                to="/admin/feedback"
                data-testid="navbar-admin-feedback-link"
                className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-full text-sm text-[#6E6860] hover:text-[#2D2A26] hover:bg-[#F5F2EA] transition-colors"
              >
                <Inbox className="h-4 w-4" strokeWidth={1.5} /> Feedback
              </Link>
            )}
            <button
              onClick={startNew}
              data-testid="navbar-new-issue-button"
              className="flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium bg-[#4A5D4E] text-[#FDFBF7] hover:bg-[#3B4A3E] transition-all hover:-translate-y-0.5 shadow-sm"
            >
              <Plus className="h-4 w-4" strokeWidth={2} /> Explore an Issue
            </button>
            <button
              onClick={doLogout}
              data-testid="navbar-logout-button"
              className="p-2 rounded-full text-[#6E6860] hover:text-[#B27A70] hover:bg-[#F5F2EA] transition-colors"
              title="Sign out"
            >
              <LogOut className="h-5 w-5" strokeWidth={1.5} />
            </button>
          </nav>
        )}
        {!user && (
          <a
            href={WEBSITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-website-link"
            className="flex items-center gap-1.5 px-3 py-2 rounded-full text-sm text-[#6E6860] hover:text-[#2D2A26] hover:bg-[#F5F2EA] transition-colors"
          >
            <ExternalLink className="h-4 w-4" strokeWidth={1.5} /> Back to Website
          </a>
        )}
      </div>
    </header>
  );
}
